export default __webpack_public_path__ + "282c6a9b0be71eed70ed7aa681c6befe.svg";